export default __webpack_public_path__ + "static/media/mongodb.71878b73.svg";